<template lang="pug">
.mt-5()
  v-row.align-center(v-for="(item, index) in fields" :key="index")
    v-col(cols="3")
      span(v-if="isMetaData") {{ item.name === 'Monatlicher Beitrag' && frequency === 'Jährlich' ? "Jährlicher Beitrag" : item.name }}
      v-checkbox(
        v-else
        dense
        hide-details
        :label="item.name"
        v-model="item.active"
        @change="handleRowVisibilityChange(item, index)"
      )
    v-col(
      v-if="isMetaData || item.active"
      cols="3"
      class="test-dd-col"
    )
      v-select(
        hide-details
        v-if="item.type === 'dropdown_vs' && (isFirmengebaude(themeName))"
        outlined
        :items="item.dp_values"
        :label="item.dp_desc"
        v-model="item.dd_selection"
        @change="handleDropdownVSChange(item, index)"
      )
      v-text-field(
        v-else-if="!isMetaData"
        outlined
        hide-details
        label="Angezeigter Name"
        v-model="item.display_name"
        dense
        @change="$emit('changeVal', [{ path: `${index}.display_name`, value: item.display_name }])"
      )
    v-col(
      v-if="isMetaData || item.active"
      cols="3"
      v-for="(valType, idx) in valTypes"
      :key="idx"
      class="test-col"
    )
      v-text-field(
        hide-details
        v-if="item.type === 'string' || (item.type === 'dropdown_vs' && isFirmengebaude(themeName) && item.dd_selection !== 'Versicherungssumme')"
        outlined
        dense
        :disabled="item.type === 'dropdown_vs' && (!item.dd_selection || item.dd_selection === 'Gebäudegarantie')"
        v-model="item[`${ valType }_value`]"
        @change="$emit('changeVal', [{ path: `${index}.${valType}_value`, value: item[`${ valType }_value`] }])"
      )
      n-date-picker(
        hide-details
        v-else-if="item.type === 'date'"
        v-model="item[`${ valType }_value`]"
        :input-rules="[ rules.valid_date('') ]"
        @change="$emit('changeVal', [{ path: `${index}.${valType}_value`, value: item[`${ valType }_value`] }])"
      )
      n-number-input(
        class="test"
        hide-details
        dense
        v-else-if="item.type === 'currency' || (item.type === 'dropdown_vs' && (item.dd_selection === 'Versicherungssumme' || !isFirmengebaude(themeName))) || item.type === 'float' || item.type === 'int'"
        :type="item.type === 'float' ? 'f' : item.type === 'int' ? 'i' : 'w'"
        outlined
        :placeholder="item.type === 'currency' || (item.type === 'dropdown_vs' && item.dd_selection === 'Versicherungssumme') ? '€' : ''"
        :value="item[`${ valType }_value`]"
        :id="`${valType}-field-${Date.now() + index}-${isMetaData}`"
        :decimals="item.type !== 'int' ? (parseInt(item.format) || 2) : 0"
        @change="(val) => $emit('changeVal', [{ path: `${index}.${valType}_value`, value: val }])"
      )
      v-switch(
        class="toggle"
        inset
        v-else-if="!item.type"
        v-model="item[`${ valType }_value`]"
        hide-details
        @change="$emit('changeVal', [{ path: `${index}.${valType}_value`, value: item[`${ valType }_value`] }])"
      )
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import FormMixin from '@/mixins/form'

@Component({

  mounted () {
    this.fields.forEach(f => {
      if (!f.dd_selection && f.type === 'dropdown_vs') f.dd_selection = 'Gebäudegarantie'
    })
  },

  mixins: [
    FormMixin
  ],

  components: {
    NNumberInput: () => import('@/components/common/n-number-input'),
  }
})

export default class FormGenerate extends Vue {
  @Prop({ type: Array | null, default: [] }) fields
  @Prop({ type: Boolean, default: true }) isMetaData
  @Prop({ type: String, default: '' }) themeName
  @Prop({ type: String, default: '' }) frequency

  valTypes = ['cur', 'new']
  formKey = 0

  @Watch('fields')
  onFormChange () {
    this.formKey++
  }

  handleDropdownVSChange (item, index) {
    this.$emit('changeVal', [
      { path: `${ index }.dd_selection`, value: item.dd_selection },
      { path: `${ index }.cur_value`, value: item.dd_selection === 'Gebäudegarantie' ? 'Gebäudegarantie' : null },
      { path: `${ index }.new_value`, value: item.dd_selection === 'Gebäudegarantie' ? 'Gebäudegarantie' : null }
    ])
  }

  handleRowVisibilityChange (item, index) {
    if (item.active) {
      // this.$emit('setThemeActive', [{ path: `${index}.active`, value: item.active }])
      this.$emit('changeVal', [{ path: `${ index }.active`, value: item.active }])
    } else {
      this.$emit('changeVal', [{ path: `${ index }.active`, value: item.active }])
    }
  }

  isFirmengebaude (themeName) {
    return themeName.includes('Firmengebäude') && (+themeName.slice(-1) >= 1 || +themeName.slice(-1) <= 5)
  }
}
</script>

<style>
.toggle>.v-input--switch--inset .v-input--switch__track, .v-input--switch--inset .v-input--selection-controls__input {
  order: 2;
}
</style>
